import { render, staticRenderFns } from "./MyWorkerTabs.vue?vue&type=template&id=59934172&scoped=true&"
import script from "./MyWorkerTabs.vue?vue&type=script&lang=js&"
export * from "./MyWorkerTabs.vue?vue&type=script&lang=js&"
import style0 from "./MyWorkerTabs.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MyWorkerTabs.vue?vue&type=style&index=1&id=59934172&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59934172",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ExperiencesTable: require('/workspace/components/Experiences/ExperiencesTable.vue').default,PotentialWorkerSkillsTable: require('/workspace/components/PotentialWorker/PotentialWorkerSkillsTable.vue').default})
